import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "TimeOffCalendar",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  getTimeOffCalendar,
  getTimeOffCalendarError,
  getTimeOffCalendarSuccess,
} = slice.actions;

reducerRegistry.register("timeOffCalendar", reducer);
